module.exports = __webpack_public_path__ + "img/12.05e8efdd.jpg";